"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getWindow;

// For the purposes of correctly mocking the window object in Jest,
// this is a safe way of returning it for tests to work as expected.
function getWindow() {
  if (typeof window === undefined) {
    throw new Error('window not available');
  }

  return window;
}